import { ReactElement } from 'react';

export interface ProducerNavItem {
  label: string;
  href: string;
  icon?: ReactElement;
}

export interface ProducerNavSection {
  title?: string;
  items: ProducerNavItem[];
}

export interface ProducerNavModule {
  id: string;
  label: string;
  icon: ReactElement;
  href?: string;
  sections?: ProducerNavSection[];
}

// Icons are injected at render time to avoid importing MUI icons here.
// The config is built by the hook/component that consumes it.
// This file provides the types and a factory function.

export function buildProducerNavConfig(
  icons: {
    requestJob: ReactElement;
    jobs: ReactElement;
    chat: ReactElement;
    orders: ReactElement;
  },
  options?: { buyerOnly?: boolean },
): ProducerNavModule[] {
  if (options?.buyerOnly) {
    return [
      {
        id: 'orders',
        label: 'Your Orders',
        icon: icons.orders,
        href: '/dashboard',
      },
      {
        id: 'chat',
        label: 'Chat',
        icon: icons.chat,
        href: '/chat',
      },
    ];
  }

  return [
    {
      id: 'requestJob',
      label: 'Request a Job',
      icon: icons.requestJob,
      href: '/scheduling',
    },
    {
      id: 'jobs',
      label: 'Your Jobs',
      icon: icons.jobs,
      href: '/dashboard',
    },
    {
      id: 'chat',
      label: 'Chat',
      icon: icons.chat,
      href: '/chat',
    },
  ];
}
